import { Drawer, GlobalToken } from 'antd';
import styled from 'styled-components';

export const StyledMainDrawer = styled(Drawer)<{ theme: { token: GlobalToken } }>`
  &.validation-tool-main-drawer {
    .ant-drawer-content-wrapper {
      background: ${({ theme: { token } }) => token.colorBgContainer};
      transition: ${({ theme: { token } }) => `transform ${token.motionDurationMid} ${token.motionEaseInOut}`};
    }

    .ant-drawer-body {
      padding: ${({ theme: { token } }) => `${token.padding}px ${token.paddingLG}px`};
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: stretch;
      overflow: hidden;
      border-top: none;
    }

    &.ant-drawer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
    }

    .ant-btn {
      height: ${({ theme: { token } }) => token.controlHeightLG}px;
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
    }
  }
`;

export const StyledNotificationDrawer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${({ theme: { token } }) => token.zIndexPopupBase + 1};
`;
